import { Controller } from "@hotwired/stimulus"
import { decode } from "blurhash"

// Connects to data-controller="blurhash"
// Decodes a blurhash string onto a canvas, then fades to the real image on load.
export default class extends Controller {
  static targets = ["image", "canvas"]
  static values = { hash: String }

  connect() {
    this.renderBlurhash()

    if (this.imageTarget.complete) {
      this.reveal()
    } else {
      this.imageTarget.addEventListener("load", () => this.reveal(), { once: true })
    }
  }

  disconnect() {
    this.imageTarget.removeEventListener("load", () => this.reveal())
  }

  renderBlurhash() {
    const canvas = this.canvasTarget
    const width = 32
    const height = 32

    canvas.width = width
    canvas.height = height

    const pixels = decode(this.hashValue, width, height)
    const ctx = canvas.getContext("2d")
    const imageData = ctx.createImageData(width, height)
    imageData.data.set(pixels)
    ctx.putImageData(imageData, 0, 0)
  }

  reveal() {
    this.canvasTarget.classList.add("blurhash-canvas--hidden")
    this.imageTarget.classList.add("blurhash-image--loaded")
  }
}
